import type { GasVolumeCompressibilityCalculator } from "../d";
import { withoutAbsentGasComponents } from "@/libs/calculations/gasPhase/gasTable";

export const pengRobinsonCompressibilityCalculator: GasVolumeCompressibilityCalculator =
  params => {
    const { gasProperties } = params;
    const gasCompressibilityFactor = withoutAbsentGasComponents(
      gasProperties
    ).reduce((sum, g) => sum + g.gasZ, 0);
    return {
      gasCompressibilityFactor
    };
  };
